import svgUrl from "ni:svgr;7-M1vzzgvROUnExFPCtlIR6Gawtwe9r5iUu2N8_rU_Y";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const ExpandIcon = props => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path stroke="currentColor" d="M4 8h8M8 4v8" /></svg>;
const Memo = memo(ExpandIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ExpandIcon";
}